module.exports = __webpack_public_path__ + "img/red_heart.95f2338a.png";